import { render, staticRenderFns } from "./SwitchLoader.vue?vue&type=template&id=098d54fe&scoped=true"
import script from "./SwitchLoader.vue?vue&type=script&lang=js"
export * from "./SwitchLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098d54fe",
  null
  
)

export default component.exports